import { Component } from '@angular/core';

@Component({
  selector: 'app-landing-data-processing',
  templateUrl: './landing-data-processing.component.html',
  styleUrls: ['../landing/landing.component.scss', './landing-data-processing.component.scss']
})
export class LandingDataProcessingComponent {

}
